import axios from "axios";
// import store from "@/store/store";
// import app from "@/main";
import jwt_decode from "jwt-decode";
import _ from "lodash";
// import alertify from "alertify.js";
import moment from "moment";
var token = localStorage.getItem("jwt") || null;

function verify(token) {
  return axios.post(`${process.env.VUE_APP_CAS_URL}/api-token-verify/`, {
    token,
  });
}

async function refresh(token) {
  try {
    let {
      data: { token: newToken },
    } = await axios.post(`${process.env.VUE_APP_CAS_URL}/api-token-refresh/`, {
      token,
    });
    localStorage.setItem("jwt", newToken);
    let { exp } = jwt_decode(newToken);
    let timeout = moment().diff(
      moment(exp * 1000).subtract(30, "seconds"),
      "seconds"
    );
    // console.log(`Setting refresh in ${Math.abs(timeout)} seconds`);
    setTimeout(() => refresh(newToken), Math.abs(timeout) * 1000);
  } catch (err) {
    router.push(
      `${process.env.VUE_APP_CAS_URL}/login?service=${window.location.href}`
    );
  }
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export function getToken() {
  return localStorage.getItem("jwt") || getCookie("jwt_synapps");
}
// let token = localStorage.getItem("jwt");
// if (!token) {
//   token = process.env.VUE_APP_TOKEN;
// }

export function getUserData() {
  let res = jwt_decode(getToken());
  return res;
}

export default function setupApi(url) {
  let instance = axios.create({
    baseURL: url,
    headers:
      _.includes(url, "imdcapps") || _.includes(url, "localhost")
        ? {
            authorization: `jwt ${getToken()}`,
          }
        : {},
  });
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (401 === error.response.status) {
        console.log(window.location.href);
        // if (_.includes(window.location.href, "localhost")) {
        //   alertify.prompt("Insert jwt token", (val) => {
        //     document.cookie = `jwt_synapps=${val}`;
        //     window.location.reload();
        //   });
        // } else {
        //   alertify.error(
        //     "You seem to have incorrect authorization credentials. We will redirect you to the login page in 3 seconds."
        //   );
        //   setTimeout(() => {
        //     window.location.replace(process.env.VUE_APP_CAS_URL + "/logout");
        //     return Promise.reject(error);
        //   }, 3000);
        // }
      } else {
        return Promise.reject(error);
      }
    }
  );

  return instance;
}

export function waitForAuth() {
  return new Promise(async (resolve, reject) => {
    if (token) {
      try {
        await verify(token);
      } catch (err) {
        token = null;
        localStorage.removeItem("jwt");
      }
    }
    if (!token) {
      let url = new URL(window.location.href);
      window.history.replaceState(null, null, window.location.pathname);

      let ticket = url.searchParams.get("ticket");
      if (ticket) {
        let { data: resp } = await axios.get(
          `${process.env.VUE_APP_CAS_URL}/serviceValidate?ticket=${ticket}&service=${window.location.href}`
        );
        let parser = new DOMParser();
        resp = parser.parseFromString(resp, "text/xml");
        try {
          token = resp.getElementsByTagName("cas:jwt_synapps")[0].innerHTML;
        } catch (err) {
          // failed: no token in cas response
          window.location.replace(`${process.env.VUE_APP_CAS_URL}/logout`);
          reject();
        }
        localStorage.setItem("jwt", token);
      } else {
        window.location.replace(
          _.replace(
            `${process.env.VUE_APP_CAS_URL}/login?service=${window.location.href}`,
            "#/",
            ""
          )
        );
      }
    }
    if (token) {
      const { exp } = jwt_decode(token);
      const timeout = moment().diff(
        moment(exp * 1000).subtract(30, "seconds"),
        "seconds"
      );
      // console.log(`Setting refresh in ${Math.abs(timeout)} seconds`);

      setTimeout(() => {
        refresh(token);
      }, Math.abs(timeout) * 1000);
      resolve();
    }
  });
}
